import { render, staticRenderFns } from "./Brasil.vue?vue&type=template&id=fa2e756a&"
import script from "./Brasil.vue?vue&type=script&lang=js&"
export * from "./Brasil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports